const GOOGLE_WEB_CLIENT_ID =
  process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID!;

let gsiLoaded = false;

function loadGsiScript(): Promise<void> {
  if (gsiLoaded) return Promise.resolve();
  return new Promise((resolve, reject) => {
    if (typeof document === "undefined") {
      return reject(new Error("Not in a browser environment"));
    }
    // Check if already loaded
    if ((window as any).google?.accounts?.id) {
      gsiLoaded = true;
      return resolve();
    }
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      gsiLoaded = true;
      resolve();
    };
    script.onerror = () => reject(new Error("Failed to load Google Identity Services"));
    document.head.appendChild(script);
  });
}

export async function signInWithGoogleWeb(): Promise<{ idToken: string }> {
  await loadGsiScript();

  return new Promise((resolve, reject) => {
    const google = (window as any).google;
    if (!google?.accounts?.id) {
      return reject(new Error("Google Identity Services not available"));
    }

    google.accounts.id.initialize({
      client_id: GOOGLE_WEB_CLIENT_ID,
      callback: (response: any) => {
        if (response.credential) {
          resolve({ idToken: response.credential });
        } else {
          reject(new Error("No credential received"));
        }
      },
      auto_select: false,
    });

    // Use the One Tap prompt
    google.accounts.id.prompt((notification: any) => {
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        // Fallback: render a temporary button and click it
        const container = document.createElement("div");
        container.id = "google-signin-temp";
        container.style.position = "fixed";
        container.style.top = "50%";
        container.style.left = "50%";
        container.style.transform = "translate(-50%, -50%)";
        container.style.zIndex = "99999";
        container.style.backgroundColor = "rgba(0,0,0,0.5)";
        container.style.padding = "40px";
        container.style.borderRadius = "16px";
        document.body.appendChild(container);

        google.accounts.id.renderButton(container, {
          theme: "outline",
          size: "large",
          type: "standard",
          text: "signin_with",
          width: 300,
        });

        // Clean up on click outside
        const cleanup = () => {
          container.remove();
          document.removeEventListener("keydown", escHandler);
        };
        const escHandler = (e: KeyboardEvent) => {
          if (e.key === "Escape") {
            cleanup();
            reject(new Error("cancelled"));
          }
        };
        document.addEventListener("keydown", escHandler);
      }
    });
  });
}
